import { render, staticRenderFns } from "./HotelDescriptionLocation.vue?vue&type=template&id=bf4c970e&"
import script from "./HotelDescriptionLocation.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelDescriptionLocation.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HotelDescriptionLocation.vue?vue&type=style&index=0&id=bf4c970e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports